package dev.bitspittle.droidconSf24.pages.sections.kobweb.basics

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun KobwebCli2Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/basics/KobwebCli2.md", mapOf("data-auto-animate-restart" to listOf(), "behaviors" to listOf("auto-fragment LI", "auto-progress-fragments 50")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("project-structure") }) {
                org.jetbrains.compose.web.dom.Text("Project structure")
            }
            Folders(Modifier.fontSize(1.2.cssRem).textAlign(TextAlign.Center)) {
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text(".kobweb/conf.yaml")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("build.gradle.kts")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("gradle/libs.versions.toml")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("site")
                        org.jetbrains.compose.web.dom.Ul {
                            org.jetbrains.compose.web.dom.Li {
                                org.jetbrains.compose.web.dom.Text("build.gradle.kts")
                            }
                            org.jetbrains.compose.web.dom.Li {
                                org.jetbrains.compose.web.dom.Text("src")
                                org.jetbrains.compose.web.dom.Ul {
                                    org.jetbrains.compose.web.dom.Li {
                                        org.jetbrains.compose.web.dom.Text("jsMain")
                                        org.jetbrains.compose.web.dom.Ul {
                                            org.jetbrains.compose.web.dom.Li {
                                                org.jetbrains.compose.web.dom.Text("components")
                                                org.jetbrains.compose.web.dom.Ul {
                                                    org.jetbrains.compose.web.dom.Li {
                                                        org.jetbrains.compose.web.dom.Text("layouts")
                                                        org.jetbrains.compose.web.dom.Ul {
                                                            org.jetbrains.compose.web.dom.Li {
                                                                org.jetbrains.compose.web.dom.Text("MarkdownLayout.kt")
                                                            }
                                                            org.jetbrains.compose.web.dom.Li {
                                                                org.jetbrains.compose.web.dom.Text("PageLayout.kt")
                                                            }
                                                        }
                                                    }
                                                    org.jetbrains.compose.web.dom.Li {
                                                        org.jetbrains.compose.web.dom.Text("sections")
                                                        org.jetbrains.compose.web.dom.Ul {
                                                            org.jetbrains.compose.web.dom.Li {
                                                                org.jetbrains.compose.web.dom.Text("Footer.kt")
                                                            }
                                                            org.jetbrains.compose.web.dom.Li {
                                                                org.jetbrains.compose.web.dom.Text("NavHeader.kt")
                                                            }
                                                        }
                                                    }
                                                    org.jetbrains.compose.web.dom.Li {
                                                        org.jetbrains.compose.web.dom.Text("widgets")
                                                        org.jetbrains.compose.web.dom.Ul {
                                                            org.jetbrains.compose.web.dom.Li {
                                                                org.jetbrains.compose.web.dom.Text("IconButton.kt")
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            org.jetbrains.compose.web.dom.Li {
                                                org.jetbrains.compose.web.dom.Text("pages")
                                                org.jetbrains.compose.web.dom.Ul {
                                                    org.jetbrains.compose.web.dom.Li {
                                                        org.jetbrains.compose.web.dom.Text("Index.kt")
                                                    }
                                                }
                                            }
                                            org.jetbrains.compose.web.dom.Li {
                                                org.jetbrains.compose.web.dom.Text("AppEntry.kt")
                                            }
                                        }
                                    }
                                    org.jetbrains.compose.web.dom.Li {
                                        org.jetbrains.compose.web.dom.Text("resources")
                                        org.jetbrains.compose.web.dom.Ul {
                                            org.jetbrains.compose.web.dom.Li {
                                                org.jetbrains.compose.web.dom.Text("markdown/About.md")
                                            }
                                            org.jetbrains.compose.web.dom.Li {
                                                org.jetbrains.compose.web.dom.Text("public/favicon.ico")
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            SpeakerNotes {
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("No index.html in sight!")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Gradle build scripts set up for you")
                    }
                }
            }
        }
    }
}
